var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .st1, .st2 {\n        fill: #bd1006;\n      }\n\n      .st2 {\n        stroke: #1d1d1b;\n      }\n\n      .st2, .st3 {\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n\n      .st3 {\n        fill: none;\n        stroke: #3c3c3b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 15.6,
    cy: 15.5,
    r: 14.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,3.8v7.5H1.4c-.4,1.3-.6,2.7-.6,4.2s.2,2.8.6,4.1h5.2v7.5c2.3,1.8,5.2,2.9,8.3,3v-10.6h14.8c.4-1.3.6-2.7.6-4.1s-.2-2.8-.6-4.2h-14.8V.8c-3.1.1-6,1.2-8.3,3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.9.8c-.5,0-1,.2-1.5.2h0c0,0,0,11.7,0,11.7h16.6c0-.5-.2-1-.3-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.4,11.3c-.1.5-.2.9-.3,1.4h6.9V2.8c-.5.3-1,.6-1.4,1h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,19.5c.1-.4.2-.9.3-1.3H13.4v11.8c.5,0,1,.1,1.5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,27.1c.4.3.9.7,1.4,1v-9.9H1.1c0,.5.2.9.3,1.4"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 15.6,
    cy: 15.5,
    r: 14.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDk);
export default __webpack_public_path__ + "static/media/dk.2bae800a3e73b3fc033c8644a944939f.svg";
export { ForwardRef as ReactComponent };